import {
  DsItem,
  BuilderStyle,
  StyleRef,
  OpenColorPickerFn,
  OpenLinkPanelFn,
} from '@wix/public-editor-platform-interfaces';
import { PlatformSDKShape } from '../PlatformSDKShape';
import { BaseSDKShape } from '../BaseSDKShape';

export class ExternalPanelsSDKShape extends BaseSDKShape {
  async getData() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.externalPanels.getData();
  }

  async setData(newData: DsItem) {
    const privateAPI = await this.getPlatformPrivateAPI();

    return privateAPI.externalPanels.setData(newData);
  }

  async getStyle() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.externalPanels.getStyle();
  }

  async setStyle(newStyle: Partial<BuilderStyle> | StyleRef) {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.externalPanels.setStyle(newStyle);
  }

  async getTheme() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.externalPanels.getTheme();
  }

  async selectMedia() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.externalPanels.selectMedia();
  }

  async selectLink(...options: any): Promise<OpenLinkPanelFn> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.externalPanels.selectLink(...options);
  }

  async selectColor(...options: any): Promise<OpenColorPickerFn> {
    return async () => {
      const privateAPI = await this.getPlatformPrivateAPI();
      return privateAPI.externalPanels.selectColor(...options);
    };
  }

  async translate(key: string | string[], values?: Record<string, any>) {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.externalPanels.translate(key, values);
  }
}

export default new PlatformSDKShape(ExternalPanelsSDKShape)
  .withPublicMethod('getTheme')
  .withPublicMethod('getData')
  .withPublicMethod('getStyle')
  .withPublicMethod('selectColor')
  .withPublicMethod('selectLink')
  .withPublicMethod('selectMedia')
  .withPublicMethod('setData')
  .withPublicMethod('setStyle')
  .withPublicMethod('translate')
  .build();
